<script setup>

import '@css/pages/gameDetails.css'

import {computed, onMounted, reactive} from "vue"
import {useRoute} from "vue-router"

import ResponsiveImage from "@shared/components/atoms/ResponsiveImage.vue"
import {useAccountStore} from "@shared/stores/AccountStore"
import {useGameDetailStore} from "@shared/stores/GameDetailStore"
import {useGamePlayStore} from "@shared/stores/GamePlayStore"
import {useGameStore} from "@shared/stores/GameStore"
import {useProvidersStore} from "@shared/stores/ProvidersStore"
import useHelpers from "@shared/composables/useHelpers"

const state = reactive({
    isSetRatingOpen: false,
})

const accountStore = useAccountStore()
const gamePlayStore = useGamePlayStore()
const gameStore = useGameStore()
const gameDetailStore = useGameDetailStore()
const providersStore = useProvidersStore()

const {sanitizeHtml} = useHelpers()
const route = useRoute()

const game = computed(() => gameStore.getGameBySlug(route.params.gameCode))
const gameDetails = computed(() => gameDetailStore.game)
const provider = computed(() => providersStore.providers.find(p => p.product === game.value.product))

const gameImageSrc = computed(() => gameDetails.value.url_thumb || game.value.url_thumb)

const isTryModeEnabled = computed(() =>
    game.value.product.toLowerCase() !== "pgsoft"
    && !game.value.category.toLowerCase().includes('live')
)

onMounted(() => {
    gameStore.fetchAllGames()
    gameDetailStore.fetchGameDetail(route.params.gameCode)
})

</script>

<template>
    <div v-if="game" id="gamePage">
        <div class="divHeaderSpacer"></div>
        <div class="divContentBackground" :style="{ backgroundImage: `url(${gameDetails.url_background})` }" :title="`${game.name} Game Review`">
            <div class="divContentContainer">
                <responsive-image :url="gameImageSrc" :sizes="[{size: 150, mediaQuery: '(max-width: 375px)'}, {size: 200, mediaQuery: '(min-width: 375px) and (max-width: 475px)'}, {size: 380, mediaQuery: '(min-width: 476px)'}]" :alt="`${game.name} Game Review`" class="imgGameThumb" />
                <div id="divGameDetails" class="authenticated">
                    <h1 class="h1GameName">{{ game.name }}</h1>
                    <h2 v-if="provider" class="h2GameProvider">{{ provider?.productRenamed }}</h2>
                    <div class="divGameCategory">{{ game.category }}</div>
                    <div class="divGameDescription">
                        <span v-if="gameDetails.description" v-html="sanitizeHtml(gameDetails.description)" />
                        <template v-else>
                            No game info currently available.
                        </template>
                    </div>
                    <button
                        id="btnPlay"
                        @click="gamePlayStore.playGame(game.game_id)"
                    >
                        PLAY
                    </button>
                    <button
                        id="btnTry"
                        v-if="isTryModeEnabled"
                        @click="gamePlayStore.playGame(game.game_id, true)"
                    >
                        TRY
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
